export const environment = {
  production: false,
  apiUrl: 'https://apitestdrive.locaviaweb.com.br/apitellma/'
};
